import createCache from "@emotion/cache";
import type { EmotionCache, Options } from "@emotion/cache";

export type CreateEmotionCacheOptions = Omit<Partial<Options>, "key"> & {
  insertionPoint?: HTMLElement;
};

export function createEmotionCache(
  options: CreateEmotionCacheOptions = {},
): EmotionCache {
  return createCache({
    ...options,
    key: "bw",
  });
}
